import { FirebaseActions } from '@web_opxp/features';

export const openExerciseSelectionAction = () => {
  return FirebaseActions.analyticsEventAction({
    eventName: 'g_exercise_selection',
  });
};
